import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { Incident, IncidentsService, IncidentTypes } from 'src/app/api/incidents.service';




@Component({
    selector: 'app-create',
    templateUrl: './create-incident.component.html',
    styleUrls: ['./create-incident.component.scss'],
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CreateIncidentComponent implements OnInit {



  constructor(
    private fb: UntypedFormBuilder,
    private incidentService: IncidentsService,
    private router: Router,
  ) {

    this.incidentReportToLink = this.router.currentNavigation()?.extras?.state?.['incidentReport'];

  }


  incidentReportToLink: Incident | null;
 
  newIncidentForm = this.fb.group({
    summary: [''],
    description: [''],
    startDate: [''],

  })

  ngOnInit(): void {
  
  }

  createIncident(incident: Partial<Incident>) {

    this.incidentService.createIncident(incident).subscribe((createdIncident) => {
      if (this.incidentReportToLink) {
        this.incidentService.linkIncidents(createdIncident.workItemId, this.incidentReportToLink.workItemId).subscribe(() => {
          this.router.navigate(['/']);
        });
      }
      else {
        this.router.navigate(['/']);
      }
    })
  }

}
